import { useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import { IUserSignUp, UserType } from "../../../Models/User";
import alert_message from "../../../Services/Alert/AlertMessage";
import { signUp } from "../../../Services/Authentication/Authentication";
import translator from "../../Extra/Translation/Translate";
import { Cookies } from "react-cookie";
import { Option as DOption } from "react-tailwindcss-select/dist/components/type";

import {
    faBriefcase,
    faEnvelope,
    faHomeUser,
    faLock,
    faUser,
    faUserEdit,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CustomButton from "../../../Landing/component/Bouton/CustomButton";
import SelectInputRegister from "../../Extra/Input/SelectInputRegister";
import useLanguage from "../../../Services/Hooks/useLanguage";
import ReCAPTCHA from "react-google-recaptcha";
import PhoneInput from "react-phone-input-2";
import { useAppDispatch } from "../../../globalState/hook";
import { loggedWithSuccess } from "../../../globalState/reducers/Auth.reducer";
import { setInstanceTokens } from "../../../Services/AxiosInstance";

type RegisterComponentProps = {
    parrain?: string;
};

const RegisterComponent = ({ parrain }: RegisterComponentProps) => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const vendo_code = searchParams.get("vendo_code");
    const [processing, setProcessing] = useState<boolean>(false);
    const recaptchaRef = useRef<ReCAPTCHA | null>(null);
    const dispatch = useAppDispatch();
    const cookies = new Cookies();
    if (parrain) {
        cookies.set("parrain", parrain);
    }
    const uidParrain = parrain
        ? parrain
        : cookies.get("parrain")
        ? cookies.get("parrain")
        : "";

    const [firstName, setFirstName] = useState<string>("");
    const [lastName, setLastName] = useState<string>("");
    const [email, setEmail] = useState<string>("");
    const [password, setPassword] = useState<string>("");
    const [repeatPassword, setRepeatPassword] = useState<string>("");
    const [agree, setAgree] = useState<boolean>(false);
    const { translate } = translator();
    const { language } = useLanguage();

    const [token, setToken] = useState<string | null>(null);

    const type: DOption[] = [
        {
            label: translate("UserType", UserType.PARTICULIER),
            value: UserType.PARTICULIER,
        },
        {
            label: translate("UserType", UserType.ENTERPRISE),
            value: UserType.ENTERPRISE,
        },
    ];
    const [userType, setUserType] = useState<DOption>(type[0]);
    const [typeUser, setTypeUser] = useState<string>(UserType.PARTICULIER);
    const [isEnterprise, setIsEnterprise] = useState<boolean>(false);
    const [entreprise, setEntreprise] = useState<string>("");
    const [siret, setSiret] = useState<string>("");
    const [phoneCountryCode, setPhoneCountryCode] = useState<string>("");
    const [phone, setPhone] = useState<string>("");

    const handleChangeUserType = (type: any) => {
        setUserType(type);
        setTypeUser(type.value);
        if (type.value == UserType.ENTERPRISE) {
            setIsEnterprise(true);
        } else {
            setIsEnterprise(false);
        }
    };

    const handleSignUp = async (e: any) => {
        e.preventDefault();
        if (token) {
            setProcessing(true);
            const payload: IUserSignUp = {
                email: email,
                first_name: firstName,
                last_name: lastName,
                username: email,
                password: password,
                uid_parrain: uidParrain,
                token: token,
                type: typeUser,
                entreprise: entreprise,
                siret: siret,
                lang: language,
                phone: phone,
                phone_country_code: phoneCountryCode,
                vendo_code: vendo_code || undefined,
            };

            try {
                const promise = signUp(payload, repeatPassword);
                alert_message
                    .promise(
                        "Registration ...",
                        promise,
                        translate("PhoneVerification", "confirmation_code"),
                    )
                    .then((data: any) => {
                        if (data && data.user) {
                            const { user, token } = data as any;
                            dispatch(loggedWithSuccess({ user }));
                            setInstanceTokens(token);
                            // navigate(RoutesNames.VerifyPhone);
                            location.reload();
                        } else {
                            recaptchaRef.current?.reset();
                            navigate(`/login`);
                        }
                    });
            } catch (error: any) {}

            setProcessing(false);
            recaptchaRef.current?.reset();
        } else {
            alert_message.error("Please verify that you are not a robot.");
        }
        setToken(null);
    };

    return (
        <>
            <form
                onSubmit={(e) => handleSignUp(e)}
                className="bg-[#384146] auth-form opacity-90 shadow-lg z-10 rounded-xl px-4 md:!px-9 py-6 md:!py-10 space-y-6 w-full mx-auto"
            >
                <div className="relative">
                    <SelectInputRegister
                        id="id-user-type"
                        options={type}
                        value={userType}
                        onChange={(val: any) => handleChangeUserType(val)}
                        required
                    />
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                        <FontAwesomeIcon
                            icon={faBriefcase}
                            className="text-white"
                        />
                    </div>
                </div>
                {isEnterprise && (
                    <div className="relative mt-4">
                        <div className="absolute !text-white inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                            <FontAwesomeIcon icon={faHomeUser} />
                        </div>
                        <input
                            type="text"
                            id="username-field"
                            className="focus:!bg-clisha-600 !border-transparent !text-white placeholder:!text-slate-300  !bg-clisha-600  w-full text-sm px-10 !py-3 !rounded-xl outline-clisha-600"
                            placeholder={translate("Register", "Company_Name")}
                            value={entreprise}
                            onChange={(e) => setEntreprise(e.target.value)}
                            required
                        />
                    </div>
                )}

                {isEnterprise && (
                    <div className="relative mt-4">
                        <div className="absolute !text-white inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                            <FontAwesomeIcon icon={faUserEdit} />
                        </div>
                        <input
                            type="text"
                            id="username-field"
                            className="focus:!bg-clisha-600 !border-transparent !text-white placeholder:!text-slate-300  !bg-clisha-600  w-full text-sm px-10 !py-3 !rounded-xl outline-clisha-600"
                            placeholder={translate(
                                "Register",
                                "Registration_Number",
                            )}
                            value={siret}
                            onChange={(e) => setSiret(e.target.value)}
                            required
                        />
                    </div>
                )}
                <div className="relative ">
                    <div className="absolute !text-white inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                        <FontAwesomeIcon icon={faEnvelope} />
                    </div>
                    <input
                        id="email-field"
                        type="email"
                        autoComplete="email"
                        required
                        className="focus:!bg-clisha-600 !border-transparent !text-white placeholder:!text-slate-300  !bg-clisha-600  w-full text-sm px-10 !py-3 !rounded-xl outline-clisha-600"
                        placeholder={translate("Register", "Email")}
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                </div>
                <div className="relative mt-4  ">
                    <PhoneInput
                        country={"de"}
                        inputClass="!bg-clisha-600 !text-white placeholder:!text-slate-300 !py-3 !w-full !border-transparent !rounded-xl !h-[45px] "
                        dropdownClass="!bg-clisha-600 !text-white placeholder:!text-slate-300 !border-transparent "
                        buttonClass=" !rounded-xl !bg-clisha-600 !border-transparent"
                        searchClass="!bg-clisha-600 !text-white placeholder:!text-slate-300 !border-transparent "
                        excludeCountries={[
                            "af",
                            "ir",
                            "iq",
                            "kp",
                            "ly",
                            "ss",
                            "sd",
                            "sy",
                            "ye",
                        ]}
                        countryCodeEditable={false}
                        enableLongNumbers={15}
                        enableSearch={true}
                        onChange={(phone, data) => {
                            if (data && phone.length > 7) {
                                const dialCode = (data as any).dialCode;
                                if (dialCode) {
                                    setPhoneCountryCode(dialCode);
                                    const number = phone
                                        .replace("+", "")
                                        .replace(dialCode, "");
                                    setPhone(number);
                                }
                            }
                        }}
                        specialLabel={translate("Profil", "Phone_number")}
                        containerClass="relative 0"
                    />
                </div>

                <div className="relative ">
                    <div className="absolute !text-white inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                        <FontAwesomeIcon icon={faUser} />
                    </div>
                    <input
                        name="firstname"
                        type="text"
                        required
                        className="focus:!bg-clisha-600 !border-transparent !text-white placeholder:!text-slate-300  !bg-clisha-600  w-full text-sm px-10 !py-3 !rounded-xl outline-clisha-600"
                        placeholder={translate("Register", "First_name")}
                        value={firstName}
                        onChange={(e) => setFirstName(e.target.value)}
                    />
                </div>

                <div className="relative ">
                    <div className="absolute !text-white inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                        <FontAwesomeIcon icon={faUser} />
                    </div>
                    <input
                        id="lastname-field"
                        type="text"
                        className="focus:!bg-clisha-600 !border-transparent !text-white placeholder:!text-slate-300  !bg-clisha-600  w-full text-sm px-10 !py-3 !rounded-xl outline-clisha-600"
                        placeholder={translate("Register", "Last_name")}
                        value={lastName}
                        onChange={(e) => setLastName(e.target.value)}
                        required
                    />
                </div>

                <div className="relative ">
                    <div className="absolute !text-white inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                        <FontAwesomeIcon icon={faLock} />
                    </div>
                    <input
                        id="password"
                        type="password"
                        className="focus:!bg-clisha-600 !border-transparent !text-white placeholder:!text-slate-300  !bg-clisha-600  w-full text-sm px-10 !py-3 !rounded-xl outline-clisha-600"
                        placeholder={translate("Register", "Password")}
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />
                </div>

                <div className="relative ">
                    <div className="absolute !text-white inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                        <FontAwesomeIcon icon={faLock} />
                    </div>
                    <input
                        id="confirm-password"
                        type="password"
                        className="focus:!bg-clisha-600 !border-transparent !text-white placeholder:!text-slate-300  !bg-clisha-600  w-full text-sm px-10 !py-3 !rounded-xl outline-clisha-600"
                        placeholder={translate("Register", "Confirm_password")}
                        value={repeatPassword}
                        onChange={(e) => setRepeatPassword(e.target.value)}
                        required
                    />
                </div>

                <div className="flex flex-wrap items-center justify-between gap-4 mt-6">
                    <div className="flex items-center">
                        <input
                            id="agreement-field"
                            type="checkbox"
                            className="size-4 shrink-0 !text-clisha-500 !border-clisha-500 focus:!ring-clisha-500  rounded"
                            checked={agree}
                            onChange={(e) => {
                                setAgree(e.target.checked);
                            }}
                        />
                        <label
                            htmlFor="remember-me"
                            className="text-slate-300 ml-3 block text-xs"
                        >
                            {translate("Register", "Agree_Clishanodes")}
                            <a
                                className="text-slate-200 mx-1"
                                href="https://clishanodes.com/general-conditions/"
                            >
                                {translate("SignIn", "Terms_Conditions")}
                            </a>{" "}
                            &
                            <a
                                className="text-slate-200 mx-1"
                                href="https://clishanodes.com/privacy-policy/"
                            >
                                {translate("SignIn", "Privacy_Policy")}
                            </a>
                        </label>
                    </div>
                </div>
                <div className="my-6 flex items-center ">
                    <hr className="w-full border-clisha-500" />
                </div>
                <div className="w-full justify-center recap">
                    {process.env.REACT_APP_RECAPTCHA_SITE_KEY && (
                        <>
                            <ReCAPTCHA
                                ref={recaptchaRef}
                                sitekey={
                                    process.env.REACT_APP_RECAPTCHA_SITE_KEY
                                }
                                onChange={(token) => setToken(token)}
                            />
                            <input
                                type="hidden"
                                value={token ?? ""}
                                name="token"
                            />
                        </>
                    )}
                </div>
                <div>
                    <CustomButton
                        href=""
                        type="submit"
                        className="w-full text-white py-3 !border-transparent hover:!bg-clisha-500 !bg-clisha-500"
                        disabled={processing}
                    >
                        {processing
                            ? "Processing ..."
                            : translate("SignIn", "Register")}
                    </CustomButton>
                </div>
            </form>
        </>
    );
};

export default RegisterComponent;
